import React, { useCallback, useState } from 'react';

export function useSlideshowInteractions({ autoplay }: { autoplay: boolean }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isPaused, setIsPaused] = useState(!autoplay);
  const playbackControlButtonRef = React.useRef<HTMLButtonElement>(null);

  const onFocus = useCallback(
    (e: React.FocusEvent) => {
      if (e.nativeEvent.target === playbackControlButtonRef.current) {
        return;
      }
      setIsFocused(true);
    },
    [setIsFocused, playbackControlButtonRef],
  );

  return {
    isHovered,
    setIsHovered,
    isFocused,
    onFocus,
    setIsFocused,
    isPaused,
    setIsPaused,
    playbackControlButtonRef,
  };
}
